<template>
  <v-container id="createMission" fluid>
    <v-row>
      <v-card class="my-12" style="width:100%">
        <GoToBanner path="KidQuests" :params="{ id: kidId }" />
        <v-toolbar color="white" class="d-flex justify-center align-center elevation-0">
          <v-toolbar-title class="body-heading-large">Create New Quest</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!isMissionCreationRequested">
          <v-row>
            <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
              <v-form :class="{ 'half-width': !isMobile }" v-model="isMissionCreationFormValid" ref="createMissionForm" v-on:submit.prevent="createMission">
                <!-- Name & Deadline -->
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field label="Quest Name" name="mission-name" type="text" outlined dense required :rules="requiredFieldRules" v-model="missionName" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-menu ref="menu" v-model="isMissionDueDatePickerOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="missionDueDate" label="Deadline" outlined dense readonly v-on="on" required :rules="requiredFieldRules"></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="missionDueDate"
                        :min="
                          this.$moment()
                            .toISOString(true)
                            .substr(0, 10)
                        "
                        @change="selectMissionDueDate"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <!-- Description -->
                <v-row>
                  <v-col cols="12" md="12">
                    <v-textarea label="Quest Description" name="mission-description" type="text" counter="500" rows="5" auto-grow outlined dense required :rules="descriptionFieldRules" v-model="missionDescription" />
                  </v-col>
                </v-row>
                <!-- Points -->
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field label="Points Value" name="mission-point-value" type="number" outlined dense :rules="pointsFieldRules" v-model="missionPoints" min="1" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="mt-2">
                      <router-link :to="{ name: 'FAQPage' }">What's the right points reward?</router-link>
                    </div>
                  </v-col>
                </v-row>
                <!-- Recurring -->
                <v-row>
                  <v-col cols="12" md="12">
                    <p>Recurring Quest?</p>
                    <v-btn-toggle v-model="missionReoccurScale" dense @change="setRecurringMission">
                      <v-btn value="days">Daily</v-btn>
                      <v-btn value="weeks">Weekly</v-btn>
                      <v-btn value="months">Monthly</v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
                <!-- Actions -->
                <v-row>
                  <v-col cols="12" md="6" class="d-flex justify-md-start justify-center">
                    <v-btn color="secondary" type="submit" :disabled="!isMissionCreationFormValid">
                      Create Quest
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text v-else class="overview-container">
          <ResultCard :success="isMissionCreationSuccess" :successMsgTitle="missionCreationSuccessTitle" :successActions="missionCreationSuccessActions" :failedMsgTitle="missionCreationFailedTitle" :failedMsgSubtitle="missionCreationFailedSubtitle" :failedActions="missionCreationFailedActions" />
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  import GoToBanner from "@/components/GoToBanner";
  import ResultCard from "@/components/ResultCard";

  export default {
    name: "CreateMission",

    data() {
      return {
        missionCreationSuccessActions: [
          {
            name: "Add another quest",
            event: this.reset,
          },
          {
            name: "View quest list",
            event: this.goToMissionList,
          },
        ],
        missionCreationFailedActions: [
          {
            name: "Cancel",
            event: this.cancel,
          },
          {
            name: "Try Again",
            event: this.tryAgain,
          },
        ],
        missionCreationSuccessTitle: "Your new quest has been created!",
        missionCreationFailedTitle: "Your new quest has not been created. Please try again.",
        missionCreationFailedSubtitle: "",
        isMissionCreationSuccess: false,
        isMissionCreationRequested: false,
        isMissionCreationFormValid: false,
        missionName: "",
        missionDescription: "",
        missionPoints: "",
        missionDueDate: "",
        isMissionReoccuring: false,
        missionReoccurScale: "",
        missionReoccurFrequency: 1,
        requiredFieldRules: [(v) => !!v || "Field cannot be empty."],
        descriptionFieldRules: [(v) => !!v || "Field cannot be empty.", (v) => (v && v.length <= 500) || "Sorry, the maximum characters amount is 500"],
        pointsFieldRules: [(v) => !!v || "Field cannot be empty.", (v) => v >= 1 || "Points value should at least be 1"],
        isMissionDueDatePickerOpen: false,
      };
    },

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },

      kidId() {
        return this.$route.params.id;
      },
    },

    components: { GoToBanner, ResultCard },

    methods: {
      reset() {
        this.isMissionCreationSuccess = false;
        this.isMissionCreationRequested = false;
        this.isMissionCreationFormValid = false;
        this.missionName = "";
        this.missionDescription = "";
        this.missionPoints = "";
        this.missionDueDate = "";
        this.isMissionReoccuring = false;
        this.missionReoccurScale = "";
        this.missionReoccurFrequency = 1;
        this.isMissionDueDatePickerOpen = false;
        this.missionCreationFailedActions = [
          {
            name: "Try Again",
            event: this.tryAgain,
          },
          {
            name: "Cancel",
            event: this.cancel,
          },
        ];
        this.missionCreationFailedTitle = undefined;
      },

      selectMissionDueDate(date) {
        this.$refs.menu.save(date);
      },

      setRecurringMission() {
        //FIXME: this should be selected by user
        this.isMissionReoccuring = true;
        this.missionReoccurFrequency = 1;
      },

      //This will assign mission to kid as well
      createMission() {
        let missionParams = {
          name: this.missionName,
          description: this.missionDescription,
          points: this.missionPoints,
          due_date: this.missionDueDate,
          child_id: this.$route.params.id,
        };
        if (this.isMissionReoccuring) {
          missionParams.reoccur_scale = this.missionReoccurScale;
          missionParams.reoccur_frequency = this.missionReoccurFrequency;
        }
        this.$store.commit("setLoadingStatus", true);
        this.$http
          .post("/missions", { mission: missionParams })
          .then((response) => this.createMissionSuccess(response))
          .catch((error) => this.createMissionFail(error));
      },

      createMissionSuccess(response) {
        this.$store.commit("addMission", response.data.mission);
        this.isMissionCreationRequested = true;
        this.isMissionCreationSuccess = true;
        this.$store.commit("setLoadingStatus", false);
      },

      createMissionFail(error) {
        let errorMsg;
        if (this.$validator.isArray(error.response.data.error)) {
          errorMsg = error.response.data.error[0];
        } else {
          errorMsg = error.response.data.error;
        }

        //TODO: this is not good, just a walkaround, should ask server to return a unique error code for this error
        if (errorMsg.trim().toLowerCase() === "points value is more than parent's remaining balance") {
          this.missionCreationFailedActions.unshift({
            name: "Purchase More Points",
            event: this.purchasePoints,
          });
        }
        this.isMissionCreationRequested = true;
        this.missionCreationFailedTitle = errorMsg;
        this.$store.commit("setLoadingStatus", false);
      },

      goToMissionList() {
        this.$router.push({ name: "KidQuests", params: { id: this.kidId } });
      },

      tryAgain() {
        this.isMissionCreationSuccess = false;
        this.isMissionCreationRequested = false;
        this.missionCreationFailedActions = [
          {
            name: "Try Again",
            event: this.tryAgain,
          },
          {
            name: "Cancel",
            event: this.cancel,
          },
        ];
        this.missionCreationFailedTitle = undefined;
      },

      cancel() {
        this.$router.go(-1);
      },

      purchasePoints() {
        this.$router.push({ name: "PointsStore" });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/CreateMission.vue